import * as SliderPrimitive from "@radix-ui/react-slider";

const STOPS = ["Not started", "Basic", "Production Ready"];
const COLORS = ["#94A3B8", "#F59E0B", "#22C55E"];

export default function SkillSlider({ value = 0, onChange, testid }) {
  const color = COLORS[value];
  return (
    <div className="w-full">
      <SliderPrimitive.Root
        data-testid={testid}
        className="relative flex w-full touch-none select-none items-center h-5"
        min={0}
        max={2}
        step={1}
        value={[value]}
        onValueChange={(v) => onChange(v[0])}
      >
        <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-[#E2E8F0]">
          <SliderPrimitive.Range className="absolute h-full rounded-full" style={{ backgroundColor: color }} />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          className="block h-5 w-5 rounded-full bg-white shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6366F1]/40 transition-transform hover:scale-110"
          style={{ border: `2px solid ${color}` }}
        />
      </SliderPrimitive.Root>
      <div className="flex justify-between mt-1.5">
        {STOPS.map((s, i) => (
          <span key={s} className="text-[10px] font-medium transition-colors" style={{ color: i === value ? color : "#CBD5E1" }}>
            {s}
          </span>
        ))}
      </div>
    </div>
  );
}
